import { useState } from 'react';

import {
  IconButton as ButtonIcon,
  ListItemIcon,
  Menu,
  MenuItem,
} from '@material-ui/core';

import {
  RiDeleteBinLine,
  RiExternalLinkLine,
  RiMore2Fill,
  RiPencilLine,
} from '@remixicon/react';

import { AttachmentFragment } from '@spotify/confidence-graphql';

import { isRenamableArtifact } from '../../artifactUtils';
import { RenameArtifactDialog } from './RenameArtifactDialog';

interface ArtifactActionsMenuProps {
  artifact: AttachmentFragment;
  resolvedDisplayName?: string;
  navigateLabel?: string;
  onNavigateToResource?: () => void;
  onDelete?: () => void;
}

export const ArtifactActionsMenu = ({
  artifact,
  resolvedDisplayName,
  navigateLabel,
  onNavigateToResource,
  onDelete,
}: ArtifactActionsMenuProps) => {
  const [renameOpen, setRenameOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const handleMenuClose = () => setAnchorEl(null);
  const renamable = isRenamableArtifact(artifact);

  return (
    <>
      <ButtonIcon
        size="small"
        aria-label="Artifact actions"
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        <RiMore2Fill size={16} />
      </ButtonIcon>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        {onNavigateToResource && (
          <MenuItem
            onClick={() => {
              onNavigateToResource();
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <RiExternalLinkLine />
            </ListItemIcon>
            {navigateLabel ?? 'Go to resource'}
          </MenuItem>
        )}
        {renamable && (
          <MenuItem
            onClick={() => {
              setRenameOpen(true);
              handleMenuClose();
            }}
          >
            <ListItemIcon>
              <RiPencilLine />
            </ListItemIcon>
            Rename
          </MenuItem>
        )}
        {onDelete && (
          <MenuItem
            onClick={() => {
              onDelete();
              handleMenuClose();
            }}
            style={{ color: 'var(--essential-negative)' }}
          >
            <ListItemIcon>
              <RiDeleteBinLine />
            </ListItemIcon>
            Delete
          </MenuItem>
        )}
      </Menu>
      {renamable && (
        <RenameArtifactDialog
          artifact={artifact}
          resolvedDisplayName={resolvedDisplayName}
          open={renameOpen}
          onOpenChange={setRenameOpen}
        />
      )}
    </>
  );
};
